<section id="history" class="page-banner parallax-section">
    <div class="container-fluid text-center">
        <div class="row">
            <!-- <div class=" wow fadeInLeft col-md-1">
                <div class="d-flex" style="height: 100px;">
                    <div class="vr"></div>
                  </div>
            </div> -->
            <div class="wow fadeInUp offset-md-3 col-md-6 col-sm-7 " data-wow-delay="0.6s">
                <h1>Our Projects</h1>
                <ul>
                  <li>
                    <a routerlink="/" href="/">Home</a>
                  </li>
                  <li>Our Projects</li>
                </ul>
            </div>
        </div> 
        <div class="container bottom-div wow fadeInUp" data-wow-delay="0.5s">
        </div>
    </div>
</section>

<div id="projects" class="wow pb-5">
    <div class="container">
        <div class="text-center wow fadeInUp" data-wow-delay="0.5s">
			<h3 class="content-title">MECHANICAL | PETROCHEMICAL PROJECT</h3>
		</div>
        <div class="row project-item pt-5">
            <div class="col-md-6 wow fadeInRight" data-wow-delay="0.5s">
                <h3>BRG3 XPLE Project</h3>
                <p><strong>(Polyethylene Project)</strong></p>
                <p>This is an extension project of a QC laboratory used for inspecting self-manufactured products within the *XLPE(cross-linked polyethylene) production facility in the Borouge Petrochemical Complex of Ruwais Industrial Complex, about 250 km west of Abu Dhabi, U.A.E. It involves constructing a plant producing XLPE, by adding additives and dicumyl peroxide using LDPE (Low Density Polyethylene) as a feed stock.</p> 
                <a class="read-more" target="_blank" href="https://en.hdec.kr/en/tech/project.aspx?bizIntro=209&searchType=PLANT#skip-menu">Read More</a>
                <div class="location"><p><strong>Location: </strong> Abu dhabi, UAE</p></div>
            </div>
            <div class="col-md-6 wow fadeInRight" data-wow-delay="0.7s">
                <img src="assets/images/projects/eng-cons/BRG3-XPLE-Project.jpg" alt="" class="img-fluid">
                <div class="source">
                    <p class="text-center">Source: <br><span><a href="https://en.hdec.kr/en/tech/project.aspx?bizIntro=209&searchType=PLANT#skip-menu">https://en.hdec.kr/en/tech/project.aspx?bizIntro=209&searchType=PLANT#skip-menu</a></span></p>
                </div>
            </div>
            <div class="hr"></div>
        </div>
        <div class="row project-item pt-5">
            <div class="project-img col-md-6 wow fadeInLeft" data-wow-delay="0.7s">
                <img src="assets/images/projects/eng-cons/HPC-Project.jpg" alt="" class="img-fluid">
                <div class="source">
                    <p class="text-center">Source: <br><span><a href="https://en.hdec.kr/en/tech/project.aspx?bizIntro=276&bizCate=OIL&searchType=PLANT#.ZGSFLHZByUl">https://en.hdec.kr/en/tech/project.aspx?bizIntro=276&bizCate=OIL&searchType=PLANT#.ZGSFLHZByUl</a></span></p>
                </div>
            </div>
            <div class="project-details col-md-6 wow fadeInLeft" data-wow-delay="0.5s">
                <h3>HPC PROJECT PACKAGE-1</h3>
                <p><strong>(Heavy feed petrochemical complex)</strong></p>
                <p>The “HPC (Heavy Feed Petrochemical Complex) Project Package-1” is a petrochemical complex worth 3 trillion won (850 billion won for Hyundai E&C) built on a 670,000㎡ site that fills the sea of Daesan-eup, Seosan-si, Chungcheongnam-do. HPC will be introduced for the first time in Asia as a facility that thermally decomposes the heavy oil remaining from the crude oil refining process to produce petrochemical products.</p> 
                <a class="read-more" target="_blank" href="https://en.hdec.kr/en/tech/project.aspx?bizIntro=276&bizCate=OIL&searchType=PLANT#.ZFtlmXZByUk">Read More</a>
                <div class="location"><p><strong>Location: </strong> Abu dhabi, UAE</p></div>
            </div>
        </div>
        <!-- <div class="row pt-5">
            <div class="col-md-6 wow fadeInLeft" data-wow-delay="0.5s">
                <h3></h3>
                <p>The “HPC (Heavy Feed Petrochemical Complex) Project Package-1” is a petrochemical complex worth 3 trillion won (850 billion won for Hyundai E&C) built on a 670,000㎡ site that fills the sea of Daesan-eup, Seosan-si, Chungcheongnam-do. HPC will be introduced for the first time in Asia as a facility that thermally decomposes the heavy oil remaining from the crude oil refining process to produce petrochemical products.</p> 
                <a class="read-more" target="_blank" href="https://en.hdec.kr/en/tech/project.aspx?bizIntro=276&bizCate=OIL&searchType=PLANT#.ZFtlmXZByUk">Read More</a>
                <div class="location"><p><strong>Location: </strong> Abu dhabi, UAE</p></div>
            </div>
            <div class="col-md-6 wow fadeInLeft" data-wow-delay="0.7s">
                <img src="assets/images/projects/eng-cons/BRG3-XPLE-Project/image-2.jpg" alt="" class="img-fluid">
            </div>
            <div class="hr"></div>
        </div> -->

        <div class="text-center wow fadeInUp pt-5">
			<h3 class="content-title">ENGINEERING PROJECTS</h3>
            <P>EXPERIENCE IN MANPOWER SUPPLY</P>
		</div>

        <div class="row project-item pt-5">
            <div class="col-md-6 wow fadeInRight" data-wow-delay="0.5s">
                <h3>The Azito Power Plant Add-on Project</h3>
                <p><strong>Passion and effort in the Ivory Coast - Poor infrastructure and unstable public order and security</strong>
                    Cote d’Ivoire means the Ivory Coast in French. The Azito Power Plant Add-on Project is Hyundai E&C’s first construction site that enabled us to enter the sub-Saharan Africa. However, concerns were raised about the area which remains unstable and has poor infrastructure.
The project was designed to convert from the simple cycle power plant to the combined cycle one consisting of two units of heat recovery steam generator, one unit of steam turbine generator, one unit of air cooled condenser and other mechanical and electrical facilities. Add-on projects are getting popular because power plants can be expanded without additional fuel consumption and power generation costs can be reduced as well.
                </p> 
                <a class="read-more" target="_blank" href="https://en.hdec.kr/en/tech/project.aspx?bizIntro=10&bizCate=FIREPOWER&searchType=ENERGY#.ZGSEu3ZByUn">Read More</a>
                <div class="location"><p><strong>Location: </strong> Abu dhabi, UAE</p></div>
            </div>
            <div class="col-md-6 wow fadeInRight" data-wow-delay="0.7s">
                <img src="assets/images/projects/eng-cons/azito-power.jpg" alt="" class="img-fluid">
                <div class="source">
                    <p class="text-center">Source: <br><span><a href="https://en.hdec.kr/en/tech/project.aspx?bizIntro=10&bizCate=FIREPOWER&searchType=ENERGY#.ZGSEu3ZByUn">https://en.hdec.kr/en/tech/project.aspx?bizIntro...</a></span></p>
                </div>
            </div>
            <div class="hr"></div>
        </div>

        <div class="row project-item pt-5">
            <div class="project-img col-md-6 wow fadeInLeft" data-wow-delay="0.7s">
                <img src="assets/images/projects/eng-cons/barakah.jpg" alt="" class="img-fluid">
                <div class="source">
                    <p class="text-center">Source: <br><span><a href="https://www.enec.gov.ae/barakah-plant/">https://www.enec.gov.ae/barakah-plant/</a></span></p>
                </div>
            </div>
            <div class="project-details col-md-6 wow fadeInLeft" data-wow-delay="0.5s">
                <h3>NUCLEAR POWER ENERGY PLANT</h3>
                <p>The Barakah Nuclear Energy Plant is located in the Al Dhafra of the Emirate of Abu Dhabi on the Arabian Gulf, approximately 53 km west-southwest of the city of Ruwais. The Plant’s four APR1400 design nuclear reactors will supply up to 25% of the UAE’s electricity needs once fully operational.</p> 
                <p>Construction of the plant commenced in July 2012, following the receipt of the Construction License from the Federal Authority for Nuclear Regulation (FANR) and a No Objection Certificate from Abu Dhabi’s environmental regulator, the Environment Agency – Abu Dhabi (EAD). 
                </p>
                <p>The Barakah plant is an important part of the UAE’s efforts to diversify its energy sources, and will provide clean and efficient energy to homes, businesses and government facilities while reducing the nation’s carbon footprint. When fully operational, the Barakah Nuclear Energy Plant is expected to prevent up to 22 million tons of carbon emissions every year, equivalent to removing 4.8 million cars from the roads.</p>
                <!-- <a class="read-more" target="_blank" href="https://en.hdec.kr/en/tech/project.aspx?bizIntro=276&bizCate=OIL&searchType=PLANT#.ZFtlmXZByUk">Read More</a> -->
                <div class="location"><p><strong>Location: </strong> Abu dhabi, UAE</p></div>
            </div>
        </div>

    </div>
</div>

<div class="pt-5 pb-5 pos-list">
    <div class="container">
        <h2 class="text-center mb-5">List of Position</h2>
        <div class="row">
            <div class="col-md-4">
                <ol start="1">
                    <li><strong>  Mechanical</strong>
                        <ul>
                            <li>Power Plant</li>
                            <li>Nuclear Energy Plant</li>
                            <li>Petro Chemical Plant</li>
                            <li>Gas Oil Separator (Pharmaceutical Project)</li>
                            <li>Mechanical, Electrical Project</li>
                        </ul>
                    </li>
                </ol>
            </div>
            <div class="col-md-4">
                <ol start="2">
                    <li><strong>Civil</strong>
                        <ul>
                            <li>Road & Buildings Construction</li>
                            <li>Cause way and Bridges</li>
                        </ul>
                    </li>
                </ol>
            </div>
            <div class="col-md-4">
                <ol start="3">
                    <li><strong>Electrical</strong> 
                        <ul>
                            <li>Electrical and Commission</li>
                        </ul>
                    </li>
                </ol>
            </div>
        </div>
    </div>
</div>

<div class="container pt-5">
    <div class="text-center wow fadeInUp pt-5">
        <h2 class="content-title">OUR PARTNERS</h2>
    </div>
    <div class="row pt-5">
        <div class="col-md-4 text-center">
            <img src="/assets/images/logo/industries/engineering-construction/hyundai-eng-cons.png" class="img-fluid" alt="">
        </div>
        <div class="col-md-4 text-center">
            <img src="/assets/images/logo/industries/engineering-construction/Hyundai_Heavy_Industries_logo.png" class="img-fluid" alt="">
        </div>
        <div class="col-md-4 text-center">
            <img src="/assets/images/logo/industries/engineering-construction/dorsch_gruppe-dc-qatar_logo-dark.png" class="img-fluid" alt="">
        </div>
        <div class="col-md-4 text-center">
            <img src="/assets/images/logo/industries/engineering-construction/samsung-engineering.png" class="img-fluid" alt="">
        </div>
        <div class="col-md-4 text-center">
            <img src="/assets/images/logo/industries/engineering-construction/samsung-heavy-industry.gif" class="img-fluid" alt="">
        </div>
        <div class="col-md-4 text-center">
            <img src="/assets/images/logo/industries/engineering-construction/IMCO.png" class="img-fluid" alt="">
        </div>
        <div class="col-md-4 text-center">
            <img src="/assets/images/logo/industries/engineering-construction/man-enterprise.jfif" class="img-fluid" alt="">
        </div>
        <div class="col-md-4 text-center">
            <img src="/assets/images/logo/industries/engineering-construction/abalto-llc.png" class="img-fluid" alt="">
        </div>
        <div class="col-md-4 text-center">
            <img src="/assets/images/logo/industries/engineering-construction/mtc-international.png" class="img-fluid" alt="">
        </div>
        <div class="col-md-4 text-center">
            <img src="/assets/images/logo/industries/engineering-construction/pledge-construction.png" class="img-fluid" alt="">
        </div>
        <div class="col-md-4 text-center">
            <img src="/assets/images/logo/industries/engineering-construction/SYNKOM.png" class="img-fluid" alt="">
        </div>
        <div class="col-md-4 text-center">
            <img src="/assets/images/logo/industries/engineering-construction/toyo-breeze-co.png" class="img-fluid" alt="">
        </div>
        <div class="col-md-4 text-center">
            <img src="/assets/images/logo/industries/engineering-construction/Hiap-Seng-Engineering.png" class="img-fluid" alt="">
        </div>
        <div class="col-md-4 text-center">
            <img src="/assets/images/logo/industries/engineering-construction/METRIX-qatar.jpg" class="img-fluid" alt="">
        </div>
        <div class="col-md-4 text-center">
            <img src="/assets/images/logo/industries/engineering-construction/Sejong-corporation.png" class="img-fluid" alt="">
        </div>
    </div>
</div>